module.exports = __webpack_public_path__ + "assets/img/game_continue.9cf8dc7a.png";